import { checkStatus, parseJSON } from '../fetch'

class HitList {
  constructor({ url = '/api/hitlist' } = {}) {
    this.base_url = url
  }

  fetchItems(ids) {
    const url = this.base_url + '/fetch/'
    const data = new FormData()
    data.append('ids', ids)

    return fetch(url, {
      method: 'POST',
      credentials: 'same-origin',
      body: data,
    })
      .then(checkStatus)
      .then(parseJSON)
  }

  sortItems(ids, field, order) {
    const url = this.base_url + '/sort/'
    const data = new FormData()
    data.append('ids', ids)
    data.append('field', field)
    data.append('order', order)

    return fetch(url, {
      method: 'POST',
      credentials: 'same-origin',
      body: data,
    })
      .then(checkStatus)
      .then(parseJSON)
  }

  fetchSpecies(ids) {
    const url = this.base_url + '/lookup/'
    const data = new FormData()
    data.append('mask_dmel', 1)
    data.append('ids', ids)

    return fetch(url, {
      method: 'POST',
      credentials: 'same-origin',
      body: data,
    })
      .then(checkStatus)
      .then(parseJSON)
  }
}

export default HitList
